import * as $ from 'jquery';
import { getCookie, setCookie } from "../../js/utils";
class Header {
  init = () => {
    const $header = $('.header');
    $header.find('.header__nav__menu__level-01__btn').on('click', function (e) {
      e.stopPropagation();
      const menuOpen = $(this).siblings('.header__nav__menu__level-02').hasClass('header__nav__menu__level-02--active');
      // Remove class and close the  existing opened menu
      $('.header__nav__menu__container').removeClass('menu--active');
      $('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      if(menuOpen) {
        $(this).parents('.header__nav__menu__container').removeClass('menu--active');
        $(this).siblings('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      } else {
        $(this).parents('.header__nav__menu__container').addClass('menu--active');
        $(this).siblings('.header__nav__menu__level-02').addClass('header__nav__menu__level-02--active');
      }
    });
    $header.find('.header__nav__menu__level-02__left__btn').on('click', function (e) {
      e.stopPropagation();
      $(this).parents('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      $(this).parents('.header__nav__menu__container').removeClass('menu--active');
    });
    $header.find('.header__nav__hamburger').on('click', function (e) {
      e.stopPropagation();
      $('body').toggleClass("nav-active");
      $(this).siblings('.header__nav__menu').toggleClass('header__nav__menu--active');
    });
    $header.find('.header__ribbon__dropdown, .header__ribbon__dropdown-menu__btn').on('click', function (e) {
      const modalActive =  $(this).parents('.header__ribbon__wrapper').hasClass('header__ribbon__wrapper__menu--active');
      $('.header__ribbon__wrapper').removeClass('header__ribbon__wrapper__menu--active');
      e.stopPropagation();
      if(modalActive) {
        $(this).parents('.header__ribbon__wrapper').removeClass('header__ribbon__wrapper__menu--active');
      } else {
        $(this).parents('.header__ribbon__wrapper').addClass('header__ribbon__wrapper__menu--active');
      }
    });
    $header.find('.header__nav__menu__level-01__item__wrapper').hover(function(){
      if($header.find('.header__nav__search.accordion').hasClass('accordion--is-expanded')) {
        $header.find('.header__nav__search__btn').trigger('click');
      }
    });
    $(document).on('click', function (e) {
      $('.header__ribbon__wrapper').removeClass('header__ribbon__wrapper__menu--active');
      $header.removeClass('dropdown-menu--active');
      // In tablet close menu, when clicked outside
      if(e.target.contains($('.header__nav__menu__level-01__item').get(0))){
        $('.header__nav__menu__container').removeClass('menu--active');
        $('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      }
    });
    // Country selector
    $('.header__ribbon__region .header__ribbon__item__btn').on('click', function() {
        var previousCultureCode = getCookie("CustomSelectedCulture");
        var selectedCultureCode = $(this).attr("data-culture-code");
        if (selectedCultureCode !== "" && selectedCultureCode !== undefined) {
          setCookie("CustomSelectedCulture", selectedCultureCode, 365);
          if (previousCultureCode === selectedCultureCode) {
            return;
          }
          else if (previousCultureCode === "en-in") {
            window.location.href = window.location.href.replace("/en", "/" + selectedCultureCode);
          }
          else if (selectedCultureCode === "en-in") {
            window.location.href = window.location.href.replace("/" + previousCultureCode, "/en");
          }
          else {
            window.location.href = window.location.href.replace(previousCultureCode, selectedCultureCode);
          }
        }
      })
  }
}
const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight();

const HeaderInstance = new Header();
HeaderInstance.init();
export { Header, HeaderInstance };